import React, { useCallback } from "react";
import client from "@culturehq/client";

import { ActionButton } from "@culturehq/components";
import { Trans } from "app/utils";
import ChqModalConfirmDelete from "components/common/ChqModalConfirmDelete";

const Connected = ({ handleUnfollow, user }) => {
  const onConfirmDelete = useCallback(
    async () => {
      await client.deleteUserConnection({ userId: user.id });
      handleUnfollow();
    },
    [handleUnfollow, user]
  );

  return (
    <div className="footer--conn person-connected">
      <ChqModalConfirmDelete
        accept="Unfollow"
        onAccept={onConfirmDelete}
        trigger={onTrigger => (
          <ActionButton onClick={onTrigger}>
            <Trans>Following</Trans>
          </ActionButton>
        )}
      >
        <Trans>Are you sure you would like to unfollow this person?</Trans>
      </ChqModalConfirmDelete>
    </div>
  );
};

export default Connected;
